module.exports = __webpack_public_path__ + "static/media/heather-1.624f343d.svg";